import triyoAPI from "../../services/api/triyo";
import { AuthActionTypes } from "./auth-types";
import { getTokenFromLogin } from "../../services/api/authentication-api";
import { getTokenFromHashbang, removeHashbangFromUrl } from "./auth-utils";

export const createAction = (type) => (payload) => ({
    payload,
    type,
});

export const setJWT = token => {
    const action = createAction(AuthActionTypes.setJWT);
    return async (dispatch) => {
        if (!token) {
            delete triyoAPI.defaults.headers.common['Authorization'];
            return dispatch(action());
        }
        triyoAPI.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return dispatch(action(token));
    };
};

export const authorize = () => {
    const action = createAction(AuthActionTypes.authorize);
    return (dispatch) => {
        const tokenFromHashbang = getTokenFromHashbang();
        if (tokenFromHashbang) {
            removeHashbangFromUrl();
            dispatch(setJWT(tokenFromHashbang));
        }
        return dispatch(action());
    };
};

export const login = userCredentials => {
    const action = createAction(AuthActionTypes.login);
    return async (dispatch) => {
        const tokenFromLogin = await getTokenFromLogin(userCredentials);
        if (tokenFromLogin) {
            triyoAPI.defaults.headers.common['Authorization'] = `Bearer ${tokenFromLogin}`;
        }
        return dispatch(action(userCredentials));
    };
};